<template>
  <div>
    <g-button :disabled="disabled" :loading="loading" @onclick="sendMail" type="primary" icon="send" label="Send" />

    <EmailQueuedSuccessDialog
      v-model="queuedSuccessDialog"
      :onClose="onClose"
      :onStay="onStayFn"
      :returnLabel="returnLabel"
      :stayLabel="stayLabel"
    />
  </div>
</template>

<script>
import EmailQueuedSuccessDialog from "./_EmailQueuedSuccessDialog";
import { EmailService } from "@/modules/email";
export default {
  props: {
    disabled: Boolean,
    subject: String,
    attachments: Array, // Defaults

    compileMailFn: Function, // RETURN Promise
    postSend: Function, // RETURN Promise
    onFinishFn: Function, // RETURN Promise
    onStayFn: Function,
    returnLabel: String,
    stayLabel: String,
    postSendPayload: { type: Function, default: null },
  },
  components: {
    EmailQueuedSuccessDialog,
  },
  data() {
    return {
      loading: false,
      queuedSuccessDialog: false,
      emailList: [],
    };
  },
  methods: {
    sendMail() {
      const accountData = this.$store.getters["AccountStore/emailCreds"];
      if (!(accountData && accountData.source && accountData.email)) {
        this.$root.$error("Email not configured to send");
        return;
      }

      const vm = this;

      this.$root.$loading.open("Compiling email...");
      this.loading = true;

      this.compileMailFn()
        .then((mailGroups) => {
          mailGroups.forEach((item) => {
            // Attach signature to the message
            item.message += this.$store.getters["AccountStore/signature"];
            // Apply styling to the message
            item.message = `<div style="font-family: 'Calibri', sans-serif; font-size: 11pt;">${item.message}</div>`;
          });

          mailGroups.sort((a, b) => (a.supplier_name < b.supplier_name ? -1 : 1));

          const data = {
            emails: mailGroups.map((item) => {
              return {
                from: accountData.email,
                from_email_source: accountData.source,
                to: item.contacts.emailList,
                cc: item.contacts.ccEmailList,
                subject: this.subject ?? item.customSubject ?? null,
                body: item.message,
                attachments: this.attachments ?? item.attachments ?? null,
                post_send_payload: this.postSendPayload ? this.postSendPayload(item) : null,
              };
            }),
          };

          return this.$store.dispatch("EmailDeliveryStore/addQueue", data);
        })
        .then(() => {
          // DONE!
          this.queuedSuccessDialog = true;
          this.loading = false;
          this.$root.$loading.end();
        })
        .catch((err) => {
          this.loading = false;
          this.$root.$loading.end();
          if (err && err.command === "AUTH LOGIN") {
            this.$root.$error("Email credentials are incorrect");
          } else {
            this.$root.$error(err);
          }
        });
    },
    sendEmail(accountData, mail, vm) {
      return EmailService._sendOneMail({
        accountData: accountData,
        subject: this.subject,
        attachments: this.attachments,

        messageBlob: mail,

        updateMessageFn: function (message) {
          vm.$root.$loading.update(message);
        },
      })
        .then(() => {
          if (this.postSend) return this.postSend(mail);
        })
        .then(() => {
          // DONE!
          this.onFinishFn();
        })
        .catch((err) => {
          throw err;
          // if (err && err.command === "AUTH LOGIN") {
          //   this.$root.$error("Email credentials are incorrect");
          // } else {
          //   this.$root.$error(err);
          // }
        });
    },
    sendOneMail(index) {
      const accountData = this.$store.getters["AccountStore/emailCreds"];
      if (!(accountData && accountData.source && accountData.email)) {
        this.$root.$error("Email not configured to send");
        return;
      }

      const vm = this;
      this.emailList[index].promise = null;

      return EmailService._sendOneMail({
        accountData: accountData,
        subject: this.subject,
        attachments: this.attachments,
        messageBlob: this.emailList[index],
        updateMessageFn: function (message) {
          vm.$root.$loading.update(message);
        },
      })
        .then((mail) => {
          // if (this.postSend) return this.postSend(mail);
        })
        .then(() => {
          // DONE!
          this.loading = false;
          this.$root.$loading.end();
          // this.$root.$success("Email sent");
          this.onFinishFn();
        })
        .catch((err) => {
          this.loading = false;
          this.$root.$loading.end();
          if (err && err.command === "AUTH LOGIN") {
            this.$root.$error("Email credentials are incorrect");
          } else {
            this.$root.$error(err);
          }
        });
      // return mailGroups[index];
    },
    onClose() {
      if (this.onFinishFn) this.onFinishFn();
    },
  },
  mounted() {
    // Get Emails
    this.$store.dispatch("AccountStore/getPersonalEmailList");
  },
};
</script>
